import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminStore } from '@/lib/store';

export interface AdminGuardProps {
  children: ReactNode;
}

/** 미인증 시 /login 으로 리다이렉트하는 라우트 가드 */
export default function AdminGuard({ children }: AdminGuardProps) {
  const isAuthed = useAdminStore((s) => s.isAuthed);
  const location = useLocation();

  if (!isAuthed) {
    // 로그인 후 원래 위치로 복귀할 수 있도록 from 전달
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
